import Swal from "sweetalert2";

export const normalizeAddons = (addons) => {
  return Object.keys(addons || {}).map((key) => ({
    id: key,
    ...addons[key],
  }));
};

export const promptForVariableProductPrice = async (product) => {
  const { value: formValues } = await Swal.fire({
    title: "Enter Item Name and Price",
    html:
      `<input id="swal-input1" class="swal2-input" placeholder="Item Name" value="${
        product.name || ""
      }">` +
      `<input id="swal-input2" type="number" class="swal2-input" placeholder="Price" min="0" step="0.01">`,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: "Set",
    preConfirm: () => {
      const name = document.getElementById("swal-input1").value.trim();
      const price = parseFloat(document.getElementById("swal-input2").value);
      if (!name) {
        Swal.showValidationMessage("Please enter a valid item name");
        return false;
      }
      if (isNaN(price) || price <= 0) {
        Swal.showValidationMessage("Please enter a valid price");
        return false;
      }
      return { name, price: price.toFixed(2) };
    },
  });

  if (formValues) {
    return {
      ...product,
      print_name: formValues.name,
      regular_price: formValues.price,
      price: formValues.price,
      base_price: formValues.price,
    };
  }

  return null;
};

export const applyTierDiscountToProduct = (
  product,
  customer_id,
  vendorCustomers,
  categories,
  tierDiscounts
) => {
  const basePrice = parseFloat(product.base_price || product.price || 0);
  const baseName = product.base_name || product.name;

  if (!Number(customer_id)) {
    return {
      ...product,
      price: basePrice.toFixed(2),
      name: baseName,
      discount: null,
      discounted_price: null,
    };
  }

  const matchedCategory = (product.categories || []).find((cat) => {
    const catInfo = categories.find(
      (c) => parseInt(c.term_id) === parseInt(cat.id)
    );
    return catInfo?.discount_enable === "1";
  });

  if (!matchedCategory) return product;

  const customer = vendorCustomers.find(
    (c) => parseInt(c.id) === parseInt(customer_id)
  );
  //   console.log(customer);
  if (!customer || !customer.customer_points) return product;

  const customerPoints = parseFloat(customer.customer_points);
  const sortedTiers = [...(tierDiscounts?.tiers || [])].sort(
    (a, b) => parseFloat(b.points) - parseFloat(a.points)
  );

  const matchedTier = sortedTiers.find(
    (tier) => customerPoints >= parseFloat(tier.points)
  );
  if (!matchedTier) return product;

  const discountPercent = parseFloat(matchedTier.discount);
  const discountAmount = (basePrice * discountPercent) / 100;
  const discountedPrice = (basePrice - discountAmount).toFixed(2);

  return {
    ...product,
    base_price: basePrice.toFixed(2),
    base_name: baseName,
    point_discount: {
      amount: discountAmount.toFixed(2),
      percent: discountPercent,
      tier: matchedTier.label,
    },
    name: `${matchedTier.label} (${discountPercent}%) - ${baseName}`,
    discounted_price: discountedPrice,
    price: discountedPrice,
  };
};
